import { axios } from 'boot/axios'

export default {
  namespaced: true,
  state: {
    items: []
  },

  getters: {
    findIndex: ({ items }) => itemId => items.findIndex(({ id }) => id === itemId),
    find: ({ items }) => itemId => items.find(({ id }) => id === itemId),

    getUser: (state, { find, findIndex }) => userId => findIndex(userId) === -1 ? {} : find(userId),
    getUserLabel: (state, { getUser }) => userId => getUser(userId).full,

    isValidUser: () => itemId => itemId && ![1, 2, 3, 4].includes(itemId),

    userOptions: ({ items }) => items.map(({ id, full }) => ({ label: full, value: id }))
  },

  actions: {
    fetchUsers ({ commit, state: { items } }) {
      if (items.length === 0) {
        axios.get('users').then(({ data }) => { commit('SET_BANKS', data) })
      }
    }
  },

  mutations: {
    SET_BANKS (state, data) { state.items = data }
  }
}
